const config_lordgun = require('./config');
const config_staging_lordgun = require('./config.staging');
const config_production_lordgun = require('./config.production');
// RUNKD
const config_runkd = require('./config.runkd');
const config_staging_runkd = require('./config.staging.runkd');
const config_production_runkd = require('./config.production.runkd');
// INWILD
const config_inwild = require('./config.inwild');
const config_staging_inwild = require('./config.staging.inwild');
const config_production_inwild = require('./config.production.inwild');

const config = {
    lordgun: {
        development: config_lordgun,
        staging: config_staging_lordgun,
        production: config_production_lordgun,
    },
    runkd: {
        development: config_runkd,
        staging: config_staging_runkd,
        production: config_production_runkd,
    },
    inwild: {
        development: config_inwild,
        staging: config_staging_inwild,
        production: config_production_inwild,
    },
};

const isEnvironmentSet =
    NODE_ENV !== null && NODE_ENV !== undefined && NODE_ENV !== '';

let environment = isEnvironmentSet
    ? NODE_ENV.toLowerCase().trim()
    : 'production';

let configObj = {
    getConfig: () => config[SITE.toLowerCase()][environment],
};

module.exports = configObj;
